import { Link } from "react-router-dom";
import { PublicShell } from "@/components/layout/PublicShell";
import { ButtonLink, Panel } from "@/components/system";
import { useCity } from "@/contexts/CityContext";
import { PATIENT_GUIDE, patientGuideStructuredData } from "@/lib/patient-guide";
import { SEO } from "@/lib/seo";

/** /guide/seeing-a-specialist — plain-language referrals, Medicare and costs. Static twin: guideContent() in scripts/prerender-markup.mjs. */
export default function PatientGuide() {
  const { city } = useCity();
  return (
    <PublicShell>
      <SEO
        title={PATIENT_GUIDE.metaTitle}
        description={PATIENT_GUIDE.description}
        path={PATIENT_GUIDE.path}
        jsonLd={patientGuideStructuredData()}
      />
      <div className="ds-container">
        <header className="ds-page-head">
          <ol className="ds-crumbs" aria-label="Breadcrumb">
            <li><Link to="/">Home</Link></li>
          </ol>
          <p className="ds-eyebrow ds-eyebrow--teal">Patient guide · {city.name}</p>
          <h1 className="ds-display-1">{PATIENT_GUIDE.title}</h1>
          <p className="ds-lead">{PATIENT_GUIDE.intro}</p>
        </header>

        <div className="ds-guide">
          <nav className="ds-guide__toc ds-panel ds-panel--tight" aria-label="On this page">
            <p className="ds-eyebrow">On this page</p>
            <ul className="ds-stack" style={{ gap: 6, listStyle: "none", margin: 0, padding: 0 }}>
              {PATIENT_GUIDE.sections.map((section) => (
                <li key={section.id}>
                  <a className="ds-link" href={`#${section.id}`}>{section.heading}</a>
                </li>
              ))}
            </ul>
          </nav>

          <article className="ds-guide__body ds-stack" style={{ gap: 40 }}>
            {PATIENT_GUIDE.sections.map((section) => (
              <section key={section.id} id={section.id} className="ds-stack" style={{ gap: 12 }} aria-labelledby={`${section.id}-heading`}>
                <h2 id={`${section.id}-heading`} className="ds-display-2">{section.heading}</h2>
                {section.paragraphs.map((paragraph) => <p key={paragraph} className="ds-body">{paragraph}</p>)}
                {"bullets" in section && section.bullets ? (
                  <ul className="ds-list">
                    {section.bullets.map((bullet) => <li key={bullet}>{bullet}</li>)}
                  </ul>
                ) : null}
              </section>
            ))}
            <Panel tone="tint">
              <h2 className="ds-title">Ready to find someone?</h2>
              <div><ButtonLink to="/directory">Browse {city.name} specialists</ButtonLink></div>
              <p className="ds-fine">{PATIENT_GUIDE.disclaimer}</p>
            </Panel>
          </article>
        </div>
      </div>
    </PublicShell>
  );
}
